export const common = {
	//Menu
	"menu.play": "Jogar",
	"menu.ranking": "Classificação",
	"menu.prizes": "Prémios",
	"menu.rules": "Regras",
	"menu.leagues": "Ligas",
	"menu.betwayAccount": "Conta Betway",
	"menu.terms": "T&C",

	//Play
	"play.heroTitle": "Prevê todos os resultados dos jogos e ganha prémios!",
	"play.heroSubtitle": "Que equipa vai ganhar? Quantos golos vão marcar? Prevê agora e compete contra os teus amigos!",
	"play.playNow": "Jogar agora",
	"play.seePrizes": "Ver prémios",
	"play.statistics": "Estatísticas",
	"play.lastMatches": "Últimos 5 jogos de cada equipa",
	"play.stats": "Estatísticas",

	//Ranking
	"ranking.season": "Época",
	"ranking.weekly": "Semanal",
	"ranking.selectType": "Selecionar tipo de classificação",
	"ranking.selectWeek": "Selecionar semana",
	"ranking.myPosition": "A minha posição",
	"ranking.points": "Pontos",
	"ranking.rank": "Posição",
	"ranking.topMembers": "Top 20 membros",
	"ranking.noRanking": "Ainda não há classificação.",
	"ranking.competitionStart": "Assim que a competição começar, todos os utilizadores que jogaram Score Predict serão classificados aqui.",
	"ranking.loadMore": "Carregar Mais",
	"ranking.loading": "Carregando...",

	//Leagues
	"leagues.heroTitle": "Compete contra os teus amigos ou junta-te a ligas públicas!",
	"leagues.heroSubtitle": "Quem tem as melhores habilidades de previsão? Cria ou junta-te a uma liga para descobrir!",
	"leagues.createLeague": "Criar uma liga",
	"leagues.joinLeague": "Juntar-se a uma liga",
	"leagues.createLeagueButton": "Criar liga",
	"leagues.joinLeagueButton": "Juntar-se à liga",
	"leagues.enterName": "Inserir nome da liga",
	"leagues.enterCode": "Inserir código de convite",
	"leagues.myLeagues": "As minhas ligas",
	"leagues.member": "membro",
	"leagues.members": "membros",
	"leagues.membersCapital": "Membros",
	"leagues.league": "Liga",
	"leagues.shareCodeText": "Os teus amigos podem juntar-se à tua liga usando este código:",
	"leagues.shareCode": "Partilhar código",
	"leagues.editLeague": "Editar liga",
	"leagues.delete": "Eliminar",
	"leagues.leave": "Sair",
	"leagues.deleteWarning": "Todo o histórico e membros serão eliminados permanentemente.",
	"leagues.leaveWarning": "Os teus pontos de previsão e classificação serão eliminados.",
	"leagues.confirmDelete": "Sim, eliminar",
	"leagues.confirmLeave": "Sim, sair",
	"leagues.cancel": "Cancelar",
	"leagues.ban": "Banir",
	"leagues.edit": "Editar",
	"leagues.save": "Guardar",

	//Errors
	"errors.savingPredictions": "Erro ao guardar previsões",

	//Predictions
	"predictions.successModal.title": "Previsões confirmadas!",
	"predictions.successModal.subtitle": "As tuas previsões foram guardadas com sucesso!",
	"predictions.successModal.close": "Fechar",
	"predictions.seasonEnd.title": "Época terminada!",
	"predictions.seasonEnd.message":
		"Terminou esta época do BW ScorePredict — bom trabalho! Parabéns ao nosso grande vencedor do prémio, [username], que ganhou uma viagem para dois para ver o Arsenal ao vivo no Emirates Stadium. Enquanto a ação faz uma pequena pausa, já nos estamos a preparar para a próxima ronda. Mantém-te atento às atualizações e prepara-te para voltar com previsões ainda mais precisas.",
	"predictions.seasonEnd.subtitle": "Mal podemos esperar para te ter de volta no jogo!",
	"predictions.seasonEnd.myPosition": "A minha posição",
	"predictions.seasonEnd.points": "Pontos",
	"predictions.seasonEnd.rank": "Posição",
	"predictions.seasonEnd.topMembers": "Top 10 membros",
	"predictions.countdown.deadline": "Prazo limite",
	"predictions.countdown.deadlineMissed": "Prazo limite perdido",
	"predictions.countdown.matchweekDeadline": "Prazo limite da jornada",
	"predictions.countdown.deadlineMissedMessage":
		"Não fizeste as tuas previsões para esta semana, por isso não foram ganhos pontos - mas há sempre a próxima semana para recuperar!",
	"predictions.countdown.days": "DIAS",
	"predictions.countdown.hours": "HORAS",
	"predictions.countdown.minutes": "MIN.",
	"predictions.countdown.seconds": "SEG.",
	"predictions.bonusFooter.loadingOdds": "A carregar odds...",
	"predictions.bonusFooter.draw": "Empate",
	"predictions.bonusFooter.unknown": "Desconhecido",
	"predictions.bonusFooter.oddsToWin": "Odds de vitória",
	"predictions.roundSelector.previousRound": "Ronda anterior",
	"predictions.roundSelector.nextRound": "Próxima ronda",
	"predictions.points.totalPoints": "Pontos totais",
	"predictions.points.currentPosition": "Posição atual",
	"predictions.points.points": "Pontos",
	"predictions.points.totalPointsLabel": "Pontos totais",
	"predictions.submitButton.submitting": "A enviar...",
	"predictions.submitButton.predictionsSaved": "Previsões guardadas",
	"predictions.submitButton.updatePredictions": "Atualizar previsões",
	"predictions.submitButton.submitAllPredictions": "Enviar todas as previsões",
	"predictions.predictionCard.result": "Resultado",
	"predictions.predictionCard.pts": "Pts",

	//Predictions Info Card
	"predictions.infoCard.title": "Prevê todos os resultados dos jogos e ganha prémios!",
	"predictions.infoCard.description":
		"Quem vai sair por cima? Quantos golos vão marcar? Prevê agora e compete contra os teus amigos! Aplicam-se regras e termos e condições.",
	"predictions.infoCard.playButton": "Jogar agora",
	"predictions.infoCard.prizesButton": "Ver prémios",

	//Common Components
	"common.shareCard.title": "Convida os teus amigos para jogar",
	"common.shareCard.description":
		"Convida os teus amigos para jogar BW ScorePredict para ver quem de vocês é o melhor gestor de futebol, e para todos terem a hipótese de ganhar prémios semanais!",
	"common.shareCard.button": "Convidar amigos",
	"common.shareCard.shareTitle": "Descarregar BetwayScores",
	"common.shareCard.shareBody": "Descarrega BetwayScores e compete contra os teus amigos no BW ScorePredict!",

	"common.accessDenied.title": "Descarregar a app Betway Scores",
	"common.accessDenied.description":
		"Para aceder a este conteúdo, por favor descarrega a aplicação Betway Scores. Obtém os últimos resultados, previsões e funcionalidades exclusivas na ponta dos dedos.",
	"common.accessDenied.rulesText": "Disponível para dispositivos iOS e Android. Descarrega agora para começar!",
	"common.accessDenied.button": "Descarregar a app Betway Scores",

	"common.prizesInfoCard.title": "Informações sobre prémios",
	"common.prizesInfoCard.description1":
		"Não precisas de ter uma conta Betway para jogar BW ScorePredict, no entanto para resgatar um prémio semanal ficando no Top 10 de uma semana, precisas de ter uma conta Betway para esses ganhos serem depositados.",
	"common.prizesInfoCard.description2": "Vê as Regras e T&C do jogo para detalhes dos prémios semanais e gerais.",
	"common.prizesInfoCard.button": "Ver regras",

	//Prizes Fragment
	"prizes.prizeCard1.title": "Grande Prémio – Ver o Arsenal no Emirates Stadium",
	"prizes.prizeCard1.description":
		"Ganha uma viagem para dois para ver o Arsenal jogar no Emirates Stadium em Londres, incluindo voos (se necessário), alojamento (se necessário) e £500 de dinheiro de bolso.",
	"prizes.prizeCard2.title": "Vencedor da ronda – Prémio em dinheiro na tua conta Betway",
	"prizes.prizeCard2.description":
		"O melhor performer de cada semana ganhará €150 (ou equivalente em moeda – ver secção 'Regras') como dinheiro depositado na sua conta Betway.",
	"prizes.prizeCard3.title": "Lugares 2-10 cada ronda – Prémio em dinheiro na tua conta Betway",
	"prizes.prizeCard3.description":
		"Aqueles que ficarem do 2º ao 10º lugar cada semana também receberão prémios em dinheiro na sua conta Betway. Ver a secção 'Regras' para as quantias exactas que podes ganhar.",

	"common.modal.pointsFormat": "+{points}pts",

	//Betway Account Fragment
	"betwayAccount.title": "Abrir uma conta Betway",
	"betwayAccount.description":
		"Não precisas de ter uma conta Betway para jogar BW ScorePredict, no entanto para resgatar um prémio semanal ficando no Top 10 de uma semana, precisas de ter uma conta Betway para esses ganhos serem depositados.",
	"betwayAccount.rulesText": "Vê as Regras e T&C do jogo para detalhes dos prémios semanais e gerais.",
	"betwayAccount.button": "Abrir uma conta Betway",
};
